export default "__VITE_ASSET__NYCcFK16__"